class StaggerHorizontal {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    this.staggerAnims = [];
    // this.debug = true;
  }

  init() {

    let _self = this;

    let staggers = $('.has-stagger-horizontal');
    if(_self.debug) console.log('StaggerHorizontal staggers?', staggers);
    if(staggers.length) {

      staggers.each(function(i,stagger){


        // let elementAnim = gsap.to(stagger.querySelector(stagger.dataset.staggerTarget), {
        //   x: "-40vw",
        //   ease: "none",
        //   paused: true
        // });
        
        // let progressTo = gsap.quickTo(elementAnim, "progress", {ease: "power3", duration: parseFloat(stagger.dataset.staggerScrub) || 0.1});
        
        let staggerAnim = gsap.to(stagger, {
          x: "-120vw",
          // ease: "none",
          ease: "power3",
          scrollTrigger: {
            // scrub: true,
            scrub: parseFloat(stagger.dataset.staggerScrub),
            trigger: stagger,
            start: "top bottom",
            end: "bottom 0%",
            markers: _self.debug,
            // onUpdate: self => progressTo(self.progress),
            // onEnter: function(){ $('body').addClass('force-hide-menus'); },
            // onEnterBack: function(){ $('body').addClass('force-hide-menus'); },
            // onLeave: function(){ $('body').removeClass('force-hide-menus'); },
            // onLeaveBack: function(){ $('body').removeClass('force-hide-menus'); },
          }
        });

        _self.staggerAnims.push(staggerAnim);

      });
      
    }

    window.StaggerHorizontal = this;

  }
}

export { StaggerHorizontal };